'use client'
import React from 'react'
import { useState } from "react";

const Layouts = ({ posts }: { posts: Array<any> }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const postsPerPage = 20; // posts per page
    const postsToShow = posts.slice(0, 100); // 100 posts show here
    const totalPages = Math.ceil(postsToShow.length / postsPerPage);

    const sortedPosts = [...postsToShow].sort((a, b) => {
        return new Date(b.frontMatter.date).getTime() - new Date(a.frontMatter.date).getTime();
    });

    const filteredPosts = sortedPosts.filter((post) =>
        post.frontMatter.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const displayedPosts = filteredPosts.slice(
        (currentPage - 1) * postsPerPage,
        currentPage * postsPerPage
    );
    return (
        <>
            <div className="justify-center items-center py-5" 
            >
                <div className=" container flex justify-center">
                    <h2
                        className="section-title mb-2" 
                    >
                        <span className="wow charsAnimIn text-center" data-splitting="chars">
                            HRMS Software
                        </span>
                    </h2>
                    <div>
                        <div className='col-md-12  overflow-hidden'>
                            <div className="row gx-5 mb-sm-30 transition duration-150 ease-in-out">
                                {displayedPosts.map((post, i) => (
                                    <div
                                        key={i}
                                        className="post-prev-2-title col-md-4 text-2xl transform scale-95 transition-transform duration-300 ease-in-out hover:scale-100 hover:shadow-lg"
                                    >
                                        <div className="p-2 rounded-lg mt-20" style={{ border: "1px solid black" }}>
                                            <h3 className="text-center justify-center mt-20" style={{ fontSize: "20px" }}>
                                                <a href={`/top-hrms/${post.slug}/`} className="text-black">
                                                    {post.frontMatter.title}
                                                </a>

                                            </h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Layouts